import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RevisionService } from '../revision.service';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
@Component({
  selector: 'app-revision-busqueda-patente',
  templateUrl: './revision-busqueda-patente.component.html',
  styleUrls: ['./revision-busqueda-patente.component.scss']
})
export class RevisionBusquedaPatenteComponent implements OnInit {

  error: string = '';

  constructor(
    private router: Router,
    private revisionService: RevisionService,
    private loading: LoadingService,
    private alerts: AlertService,
  ) { }
  ngOnInit(): void {
  }

  onInput(input: HTMLInputElement) {
    input.value = input.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (this.error) this.error = '';
  }

  buscar(valor: string) {
    const patente = valor.trim().toUpperCase();

    if (patente.length < 6) {
      this.error = 'Ingresa los 6 caracteres de la patente.';
      return;
    }

    this.error = '';
    this.loading.show();
    this.revisionService.verUltimaOt(patente).subscribe({
      next: (res: any) => {
        this.loading.hide();
        window.open('/revision/mi-revision/' + res.key, '_blank');
        /*         this.router.navigate(['/revision/mi-revision', res.key]); */
      },
      error: (err: any) => {
        this.loading.hide();
        const msg = err?.response ?? err?.error?.response ?? err?.error?.msg
          ?? 'No pudimos consultar tu orden. Intenta nuevamente.';
        this.alerts.addAlert(msg, 'danger');
      }
    });
  }


}
